import {
  GET_USERS,
  USERS_FAIL,
  USERS_LOADING,
} from '../Actions/actionTypes';

const initialState = {
  users: [],
  loading: false,
  error: null,
};

const userReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
      return { ...state, users: action.payload, error: null };
    case USERS_LOADING:
      return { ...state, loading: action.payload };
    case USERS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default userReducers;
